/** @jsx jsx */
import { jsx } from '@emotion/core'
import PropTypes from 'prop-types'
import {
  Form,
  FormInput,
  FormButton,
  Link,
  Margin,
  Text,
} from 'shared/components'
import { auth } from 'routes/route.map'
import config from 'config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as styles from './styles'

const LoginFormComponent = ({ form, onSubmit }) => {
  const browserWindow = globalThis.window

  const onGoogleLogin = () => {
    const redirect = encodeURIComponent(browserWindow?.location?.href ?? '')

    if (!browserWindow) {
      return
    }

    browserWindow.location.href = `${config.api.url}/oauth2/authorization/google?redirect=${redirect}`
  }

  return (
    <Form form={form} onSubmit={onSubmit} css={styles.smallerLabels}>
      <Margin bottom={2}>
        <FormInput
          name="email"
          label="Email"
          type="email"
          placeholder="Enter your email"
        />
      </Margin>
      <Margin tb={1}>
        <FormInput
          autoComplete="new-password"
          name="password"
          label="Password"
          type="password"
          placeholder="Enter your password"
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              return ''
            }
          }}
          secondLabel={
            <Link to={auth.resetPassword()}>
              <Text size={11}>Forgot Password?</Text>
            </Link>
          }
        />
      </Margin>
      <Margin top={2}>
        <div css={styles.controlWrapper}>
          <FormButton submit size="large" css={styles.loginButton}>
            <Text size={11} upper bold black>
              Log In
            </Text>
          </FormButton>
        </div>
      </Margin>
      <Margin top={2}>
        <div css={styles.separator}>
          <span css={styles.separatorText}>OR</span>
        </div>
      </Margin>
      <Margin top={2}>
        <FormButton
          size="large"
          type="button"
          css={styles.googleButton}
          onClick={onGoogleLogin}
        >
          <FontAwesomeIcon icon={['fab', 'google']} css={styles.googleIcon} />
          <Text size={11} bold white>
            Continue with Google
          </Text>
        </FormButton>
      </Margin>
    </Form>
  )
}

LoginFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default LoginFormComponent
